import { render, staticRenderFns } from "./SettingsPayouts.vue?vue&type=template&id=302a970b&scoped=true&"
import script from "./SettingsPayouts.ts?vue&type=script&lang=js&"
export * from "./SettingsPayouts.ts?vue&type=script&lang=js&"
import style0 from "./SettingsPayouts.vue?vue&type=style&index=0&id=302a970b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302a970b",
  null
  
)

export default component.exports